import React, { useEffect } from 'react';
import {
  Route, Routes, useLocation, useNavigate,
} from 'react-router-dom';
import { FooterOrigination } from '@honeycomb-npm/honeycomb-react';
import Header from './components/Shared/Header/Header';
import './styles/app.scss';
import Unsubscribe from './components/MainPages/Unsubscribe';
import UnsubscribeByEmail from './components/MainPages/UnsubscribeByEmail';
import { customerData } from './utils/customerDataUtils';

const App = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if ((location.pathname === '/digital/unsubscribe' || location.pathname === '/digital/unsubscribe/')
      && customerData.cif === undefined && customerData.decisionId === undefined) {
      navigate('/digital/unsubscribe/email');
      window.location.reload();
    }
  }, [location, navigate]);

  return (
    <div className="honeycomb textstyles--commbank bg-grey" id="StartMainContent">
      <Header />
      <div className="app-container container col-sm-10 px-0 bg-white">
        <Routes key={location.key}>
          <Route path="/digital/unsubscribe" element={<Unsubscribe />} />
          <Route path="/digital/unsubscribe/email" element={<UnsubscribeByEmail />} />
        </Routes>
      </div>
      <FooterOrigination />
    </div>
  );
};

export default App;
